<template>
  <div v-if="links">
    <div
      v-if="label"
      :class="$style.label"
    >
      {{ label }}
    </div>

    <CoreBoxListComponent :class="$style.list">
      <template
        v-for="link in links"
        :key="link?.id"
      >
        <SharedLinkComponent
          :link="link"
          :class="$style.link"
        >
          <CoreBoxListItemComponent :class="$style.item">
            {{ link?.label }}
          </CoreBoxListItemComponent>
        </SharedLinkComponent>
      </template>
    </CoreBoxListComponent>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  label: {
    type: String,
    required: false,
  },
  links: {
    type: Array,
    required: true
  }
})
</script>

<style module>
.root {
  --block--margin-bottom: calc(var(--unit--vertical) * 2);
}

[class*='components-core-blocks-rich-text'] + .root {
  --block--margin-top: calc(var(--unit--vertical) * 2);
}

.label {
  composes: font-helvetica font-size-small from global;
  composes: label from global;
}

.list {
  --core-box-list--stroke: var(--stroke--default);
}

.link {
  composes: font-helvetica font-size-small from global;

  display: block;

  white-space: nowrap;
  overflow: hidden;
}

.item {
  text-overflow: ellipsis;
}

.link:hover .item {
  background-color: var(--color--primary);
  color: var(--color--background);
}

.link:hover * {
  border-color: var(--color--primary);
}

.link:not([target='_blank']) [class*='string-with-arrow--arrow'] {
  display: none;
}
</style>
